/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Page_Meta_DescriptionInputs */

const en_dashboard_page_meta_description = /** @type {(inputs: Dashboard_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review portfolio activity, holdings, and Glider automation from your dashboard.`)
};

const de_dashboard_page_meta_description = /** @type {(inputs: Dashboard_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen Sie Portfolioaktivitäten, Bestände und die Glider-Automatisierung in Ihrem Dashboard.`)
};

const pt_br2_dashboard_page_meta_description = /** @type {(inputs: Dashboard_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revise a atividade do portfólio, os ativos e a automação da Glider no seu dashboard.`)
};

const tr_dashboard_page_meta_description = /** @type {(inputs: Dashboard_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrol panelinizden portföy etkinliğini, varlıklarınızı ve Glider otomasyonunu inceleyin.`)
};

const zh_cn2_dashboard_page_meta_description = /** @type {(inputs: Dashboard_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在仪表盘查看投资组合活动、持仓和 Glider 自动化。`)
};

const zh_hk2_dashboard_page_meta_description = /** @type {(inputs: Dashboard_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在儀表板查看投資組合活動、持倉及 Glider 自動化功能。`)
};

const ko_kr2_dashboard_page_meta_description = /** @type {(inputs: Dashboard_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대시보드에서 포트폴리오 활동, 보유 자산, Glider 자동화를 확인하세요.`)
};

const ru_ru2_dashboard_page_meta_description = /** @type {(inputs: Dashboard_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просматривайте активность портфеля, активы и автоматизацию Glider на панели управления.`)
};

const es_419_dashboard_page_meta_description = /** @type {(inputs: Dashboard_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa la actividad del portafolio, las posiciones y la automatización de Glider desde tu dashboard.`)
};

/**
* | output |
* | --- |
* | "Review portfolio activity, holdings, and Glider automation from your dashboard." |
*
* @param {Dashboard_Page_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const dashboard_page_meta_description = /** @type {((inputs?: Dashboard_Page_Meta_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Page_Meta_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_page_meta_description(inputs)
	if (locale === "de") return de_dashboard_page_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_dashboard_page_meta_description(inputs)
	if (locale === "tr") return tr_dashboard_page_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_dashboard_page_meta_description(inputs)
	if (locale === "zh-HK") return zh_hk2_dashboard_page_meta_description(inputs)
	if (locale === "ko-KR") return ko_kr2_dashboard_page_meta_description(inputs)
	if (locale === "ru-RU") return ru_ru2_dashboard_page_meta_description(inputs)
	return es_419_dashboard_page_meta_description(inputs)
});